module.exports = __webpack_public_path__ + "img/alt_head.2beb1671.png";